import React, { Fragment } from 'react';
import {  Container } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';

const Dashboard = () => {
    return (
      <Fragment>
        <Breadcrumbs parent='Sayfalar' title='Ana Sayfa' />
        <Container fluid={true}>
        </Container>
      </Fragment>
    );
  };
  
  export default Dashboard;
  